import React, { forwardRef } from 'react'
import PropTypes, { any } from 'prop-types'

export const SidenavSection = forwardRef((props, ref) => {
  const { as = 'li', title, children, ...rest } = props
  const Component = as

  return (
    <Component className="dev_dash__sidenav--section" ref={ref} {...rest}>
      <h5 className="dev_dash__sidenav--section__title">{title}</h5>
      <ul className="dev_dash__sidenav--section__list--container">
        {children}
      </ul>
    </Component>
  )
})

SidenavSection.displayName = 'SidenavSection'

SidenavSection.propTypes = {
  as: any,
  title: PropTypes.any,
  children: PropTypes.any.isRequired,
}
